import React, {Component, PropTypes} from 'react';
import ClientSideCacheController from '../ClientSideCacheController'

class WarningList extends Component {
  constructor(props) {
    super(props)
    this.debug = props.debug;
    this.maxCount = this.props.maxCount
    this.state = {
      warnings: []
    }
  }

  componentWillMount() {
    if (typeof window != 'object')
      return
    ClientSideCacheController.setAffiliate(this.props.affiliate)
    ClientSideCacheController.get('weatherAlert', {debug: this.props.debug}).then(warnings => this.setState({warnings}));
  }
  
  render() {

    return (<div className='warning-list'>
      <ul>
        {
          this.state.warnings.slice(0, this.maxCount).map((warning, i) => {
            return (
              <li className={warning.type.toLowerCase()} key={i} onClick={() => {
                let warnings = this.state.warnings
                warnings.forEach((w, j) => {
                  if (i === j)
                    w.open = !w.open
                  else
                    w.open = false
                })

                this.setState({warnings})
              }}>
              <div>
                <i className='fa fa-circle'/>
                <span className='county'>{warning.county}</span>
                <span className='warning'>{warning.type}</span>
                <div className={"description " + (warning.open
                  ? 'open'
                  : 'closed')}
                  >{warning.alertTextShort}</div>
              </div>

            </li>);
          })
        }
      </ul>
    </div>)
  }
}

export default WarningList



// WEBPACK FOOTER //
// ./app/components/custom/ssr/WeatherTakeover/WarningList.js